import React, { useRef, useState } from 'react';
import { renderPlainMarkdown } from '../../utils/messageHtml';

// 채널 상단 공지 (관리자는 이 자리에서 바로 추가·수정·삭제)
// pinMode: 이 방 공지를 처음에 어떻게 보일지 (나에게만): '' 기본(계정 설정 따름) | 'expand' 펼침 | 'collapse' 접힘
export function ChannelPinBar({ pin, isAdmin, isNew, collapsed, onToggleCollapsed, onSave, onRemove, pinMode = '', onChangePinMode }) {
    const [editing, setEditing] = useState(false);
    const [text, setText] = useState('');
    const down = useRef({ x: 0, y: 0 });

    if (!pin && !isAdmin) return null;

    const startEdit = (e) => { e.stopPropagation(); setText(pin?.message || ''); setEditing(true); };
    const save = async () => { if (await onSave(text)) setEditing(false); };
    const isClick = (e) => Math.abs(e.clientX - down.current.x) < 5 && Math.abs(e.clientY - down.current.y) < 5;

    return (
        <div id="pinned" className={`${isNew ? 'new-pin' : ''} ${collapsed && !editing ? 'collapsed' : ''} ${editing ? 'editing' : ''} ${pin ? '' : 'empty'}`}
            onMouseDown={e => { down.current = { x: e.clientX, y: e.clientY }; }}
            onClick={e => {
                if (!editing && isClick(e) && !window.getSelection().toString() && !e.target.closest('a, button')) onToggleCollapsed();
            }}>
            <div className="pin-bar-head">
                <strong>📌 공지</strong>
                {isAdmin && !editing && <button className="pin-edit-btn" onClick={startEdit}>{pin ? '✏️' : '+ 추가'}</button>}
                {isAdmin && !editing && pin && (
                    <button className="pin-edit-btn danger" onClick={e => { e.stopPropagation(); onRemove(); }}>🗑️</button>
                )}
            </div>
            {editing ? (
                <div onClick={e => e.stopPropagation()} className="pin-edit-area">
                    <textarea className="pin-edit-textarea" value={text} onChange={e => setText(e.target.value)} rows={3} placeholder="공지 내용을 입력하세요..." autoFocus />
                    <div className="pin-edit-actions">
                        <button className="pin-save-btn" onClick={save}>저장</button>
                        <button className="pin-cancel-btn" onClick={() => setEditing(false)}>취소</button>
                    </div>
                </div>
            ) : pin ? (
                <span dangerouslySetInnerHTML={{ __html: renderPlainMarkdown(pin.message) }} />
            ) : (
                <span className="pin-empty">공지 없음</span>
            )}
            {pin && !editing && onChangePinMode && (
                <label className="pin-mode" onClick={e => e.stopPropagation()} title="이 방에 들어올 때 공지를 펼칠지 접을지 (나에게만 적용)">
                    <span>처음 볼 때</span>
                    <select value={pinMode} onChange={e => onChangePinMode(e.target.value)} aria-label="이 방 공지 표시 방식">
                        <option value="">기본</option>
                        <option value="expand">펼침</option>
                        <option value="collapse">접힘</option>
                    </select>
                </label>
            )}
        </div>
    );
}
